import PersonalInfoForm from './PersonalInfoForm.js';

export default PersonalInfoForm;
